import { ChangeDetectionStrategy, Component, HostBinding, Input, OnChanges } from '@angular/core';
import { IconComponent } from '@nagel-assests';
import { ChipComponent, LockedIndicatorComponent } from '@nagel-components';
import { TRANSPORT_ORDER_KEYS } from 'apps/nagel-cal-disposition/src/app/configuration/consts/transportOrderKeys';
import { mapValueToLabelByKey } from 'apps/nagel-cal-disposition/src/app/utils/pickupPlanningUtils';
import { PickupPlanningTransportOrderEntityType } from 'apps/nagel-cal-disposition/src/models/planningPageTypes';
import { DEFAULT_TRANSPORT_CARD_VALUE } from 'apps/nagel-cal-disposition/src/app/configuration/consts/pickupPlanning';
import { roundToTwoDecimalPlaces } from '@nagel-utils';

const defaultLabelClass = 'compact-label max-w-[70px] truncate expansion-panel-header-label text-sm leading-tight';
const defaultTextClass = 'compact-value text-sm leading-tight font-medium max-w-[70px] truncate';

const defaultTransportOrder: PickupPlanningTransportOrderEntityType = {
    transportOrderId: 0,
    transportOrderNumber: 0,
    status: 0,
    transportMode: 0
};

@Component({
    selector: 'pickup-planning-transport-order-card',
    imports: [
        ChipComponent,
        IconComponent,
        LockedIndicatorComponent
    ],
    templateUrl: './pickup-planning-transport-order-card.component.html',
    styleUrl: './pickup-planning-transport-order-card.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PickupPlanningTransportOrderCard implements OnChanges {
    @Input() transportOrder!: PickupPlanningTransportOrderEntityType;
    @Input() displayInSingleLine: boolean = true;
    @Input() labelsClass?: string;
    @Input() textClass?: string;
    @Input() isLocked?: boolean = false;
    @Input() isExtended: boolean = false;

    @HostBinding('class.is-extended') get hostIsExtended() {
        return this.isExtended;
    }

    lockedTooltipMessage = $localize`Read-only: The Transport orders\nhave already been closed for the day.`;

    defaultValue: string = DEFAULT_TRANSPORT_CARD_VALUE;

    transportOrderCopy: PickupPlanningTransportOrderEntityType = defaultTransportOrder;

    ngOnChanges() {
        this.transportOrderCopy = {
            ...this.transportOrder
        };
    }

    getHeaderItemValue = (key: string, defaultValue: string = this.defaultValue) => {
        this.transportOrderCopy = mapValueToLabelByKey(this.transportOrderCopy, TRANSPORT_ORDER_KEYS.STATUS);
        this.transportOrderCopy = mapValueToLabelByKey(this.transportOrderCopy, TRANSPORT_ORDER_KEYS.TRANSPORT_MODE);

        let value = this.transportOrderCopy[key as keyof PickupPlanningTransportOrderEntityType];

        if (typeof value === 'number') {
            value = roundToTwoDecimalPlaces(value);
        }

        //This will be changed when we have the data from BE
        return Array.isArray(value) ? value : value?.toString() ?? defaultValue;
    };

    get wrapperClassName () {
        return this.displayInSingleLine ? 'flex single-line' : '';
    }

    get labelClassName () {
        return `${defaultLabelClass} ${this.labelsClass ? this.labelsClass : ''}`;
    };

    get textClassName () {
        return `${defaultTextClass} ${this.textClass ? this.textClass : ''}`;
    };
}